import { useAccountStore } from "@/modules/account/store"
import { loadScript } from "@/logic/loadScript"

const API_KEY = "7ca1900841d07e7b9588ca7865f3db6ab60e942f549478cc1afe51bcbb2f0262"

export async function initSupademo() {
  await loadScript("https://script.supademo.com/script.js")
}

export function updateSupademoConfig() {
  if (typeof window.Supademo === "function") {
    const accountStore = useAccountStore()
    window.Supademo(API_KEY, {
      variables: {
        email: accountStore.email || "",
        name: accountStore.username || "",
      },
    })
  }
}

export function loadSupademoDemo(demoId: string) {
  if (window.Supademo) {
    window.Supademo(API_KEY).loadDemo(demoId)
  }
}
